/** Display marker for a missing rate (no denominator). Honors the no-em-dash rule. */
export const EMPTY_RATE = 'N/A';

/** Formats a 0..1 ratio as a one-decimal percentage, or `EMPTY_RATE` when null. */
export const formatRate = (rate: number | null): string =>
    rate == null ? EMPTY_RATE : `${(rate * 100).toFixed(1)}%`;
